import styled from 'styled-components';

export const SliderStyled = styled.div<{ $gap: number }>`
  display: flex;
  flex: 1 1 100%;
  flex-wrap: nowrap;
  align-items: stretch;
  box-sizing: border-box;
  min-width: 0;
  width: 100%;
  column-gap: ${({ $gap }) => $gap}px;
  overflow-x: auto;
  overflow-y: hidden;
  overscroll-behavior-x: contain;
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
  scrollbar-width: none;
  -webkit-overflow-scrolling: touch;
  touch-action: pan-x pan-y;

  &::-webkit-scrollbar {
    display: none;
  }

  > * {
    flex: 0 0 100%;
    min-width: 0;
    scroll-snap-align: start;
  }
`;
